/**
 * PDF header rendering functions
 */

import jsPDF from 'jspdf';

export interface HeaderOptions {
  title: string;
  artist: string;
  transposedKey?: string;
}

/**
 * Render PDF header with title, artist, and metadata
 */
export function renderPDFHeader(
  doc: jsPDF,
  pageWidth: number,
  options: HeaderOptions
): void {
  const marginLeft = 15;
  const marginRight = 15;

  // Header with gray shading
  doc.setFillColor(240, 240, 240); // Light gray
  doc.rect(0, 0, pageWidth, 35, 'F');

  // Title and Artist
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text(options.title, marginLeft, 12);

  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal');
  doc.text(options.artist, marginLeft, 20);

  // Voluplan and year (right aligned)
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  const year = new Date().getFullYear().toString();
  const voluplanText = `Voluplan ${year}`;
  const voluplanWidth = doc.getTextWidth(voluplanText);
  doc.text(voluplanText, pageWidth - marginRight - voluplanWidth, 12);

  // Transposed key info (right aligned)
  if (options.transposedKey) {
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    const keyText = `Toneart: ${options.transposedKey}`;
    const keyWidth = doc.getTextWidth(keyText);
    doc.text(keyText, pageWidth - marginRight - keyWidth, 20);
  }

  // Reset color for content
  doc.setTextColor(0, 0, 0);
}

